import React, { useCallback } from 'react';

import { MapBackground, SpotOutline } from '@travel/icons/ui';
import { FlatButton } from '@travel/ui';

import { Translate } from 'core/translate';

import styles from './filtersAndList.module.scss';

type Props = {
  onOpenMap: () => void;
};

function MapButton({ onOpenMap }: Props) {
  const onKeyDown = useCallback(
    (_event: React.KeyboardEvent) => {
      if (_event.key === 'Enter' || _event.key === ' ' /** Space */) {
        _event.preventDefault();
        onOpenMap();
      }
    },
    [onOpenMap],
  );
  return (
    <div
      data-testid="providerList-map-button"
      className={styles.mapButtonWrapper}
      onClick={onOpenMap}
      onKeyDown={onKeyDown}
      role="button"
      tabIndex={0}
    >
      <MapBackground />
      <FlatButton
        icon={<SpotOutline size={16} color="white" />}
        className={styles.mapButton}
        isSmallerButtonByDefault
      >
        <Translate id="Provider_List.Map_View.Map" condition={() => 'status == List_View'} />
      </FlatButton>
    </div>
  );
}

export default MapButton;
